import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

// Shared singleton — import this everywhere instead of creating new instances
export const msalInstance = new PublicClientApplication(msalConfig);
